

//这个模块主要功能就是实现步骤和原理，
export default{
state:{
    //这个处理开关按钮
    isCollapse:false,
    //处理header增删内容
    tabsList:[{
        path: '/',
        name: 'home',
        label: '首页',
        icon: 's-home',
        url: 'Home/Home'
        }
    ]
},
        mutations:{
            //修改关闭打开的方法
            kaiisCollapse(state){
                state.isCollapse=!state.isCollapse
            },
            //更新面包屑的方法
            selectMenu(state,val){
             //判断添加的数据是否为home或者是否含有
             if(val.name !=="home"){
                // findIndex方法的作用就是，判断内部是否有这个元素，有的话返回index，没有返回-1
                      const index=state.tabsList.findIndex(item =>item.name === val.name)
             if(index===-1){
                state.tabsList.push(val)
             }
             
                    }

            },
            //删除按钮实际上就是删除的是state里面的内容，只要想删除state里面的内容就需要调用muturosu里面的方法
            shanchu1(state,tag){
                
//基本思路，找到点击删除按钮的这个元素的索引，然后用splice方法删除
const index= state.tabsList.findIndex(val=>val.name===tag.name)
            
  state.tabsList.splice(index,1)





            }

        }




}